import React from 'react'
import classNames from 'classnames'
import { ExpandableContainerProps } from './ExpandableContainer.types'
import css from './ExpandableContainer.styles.scss'

const ExpandableContainer: React.FC<ExpandableContainerProps> = ({
  className,
  children,
  isOpen,
  ...divProps
}) => (
  <div
    className={classNames(className, {
      [css.ExpandableContainer__Outer__Closed]: !isOpen,
      [css.ExpandableContainer__Outer__Open]: isOpen,
    })}
    {...divProps}
  >
    <div
      className={classNames(className, {
        [css.ExpandableContainer__Inner__Closed]: !isOpen,
        [css.ExpandableContainer__Inner__Open]: isOpen,
      })}
    >
      {children}
    </div>
  </div>
)

export default ExpandableContainer
